/**
 * Filipino: Workflows para sa Service Desk (M27 S1): ang 14 na hakbang sa ticket (mga form at card), ang mga fact ng ticket sa condition editor,
 * at ang idinadagdag ng listahan ng Workflows para sa Service desk area. Isinasama sa `engage.workflows`.
 */
export const workflowsService = {
  steps: {
    create_ticket: "Gumawa ng ticket",
    update_ticket: "I-update ang ticket",
    set_ticket_state: "Itakda ang status ng ticket",
    route_ticket: "I-route ang ticket",
    assign_ticket: "I-assign ang ticket",
    add_ticket_note: "Magdagdag ng note sa ticket",
    reply_to_ticket: "Sumagot sa ticket",
    notify_contact: "Abisuhan ang kliyente",
    link_ticket: "I-link ang ticket",
    apply_ticket_sla: "Ilapat ang SLA ng ticket",
    request_csat: "Humingi ng rating",
    ticket_intake: "Tumanggap ng ticket request",
    show_ticket_form: "Ipakita ang ticket form",
    show_my_tickets: "Ipakita ang aking mga ticket",
    lookup_asset: "Hanapin ang asset",
    schedule_visit: "Mag-iskedyul ng pagbisita",
    lookup_catalogue: "Hanapin ang mga produkto",
    check_order_status: "Tingnan ang status ng order",
    show_catalogue: "Ipakita ang mga produkto",
    create_order: "I-review at i-confirm ang order",
    show_order_status: "Ipakita ang aking mga order",
  },
  keywords: {
    create_ticket: "ticket, bagong ticket, magbukas ng ticket, incident, request",
    update_ticket: "ticket, baguhin, priority, tags, due date, uri",
    set_ticket_state: "ticket, status, resolve, isara, pending, ilipat",
    route_ticket: "ticket, routing rules, queue, team, i-route",
    assign_ticket: "ticket, assign, assignee, team, round robin, skills, ibigay kay",
    add_ticket_note: "ticket, internal note, note, mention, komento",
    reply_to_ticket: "ticket, sagot, pampublikong mensahe, sagutin ang kliyente",
    notify_contact: "kliyente, contact, e-mail, email, chat, messenger, sabihan ang kliyente, abiso",
    link_ticket: "ticket, link, ikabit ang usapan, ikonekta",
    apply_ticket_sla: "ticket, sla, deadline, service level, target sa pagsagot",
    request_csat: "rating, csat, survey, feedback, bituin, ticket",
    ticket_intake: "ticket, intake, alalahanin, assistant, mag-ulat ng problema, request",
    show_ticket_form: "ticket, form, request form, mag-ulat ng problema",
    show_my_tickets: "mga ticket, aking mga ticket, bukas na request, status",
    lookup_asset: "asset, kagamitan, serial number, tag, warranty, hanapin",
    schedule_visit: "pagbisita, inhinyero, iskedyul, appointment, field service, oras",
    lookup_catalogue: "katalogo, produkto, piyesa, hanapin, sku, consumables",
    check_order_status: "order, status, tracking, delivery",
    show_catalogue: "katalogo, mga produkto, tindahan, idagdag sa cart, piyesa",
    create_order: "order, cart, checkout, kumpirmahin, bumili, mag-order",
    show_order_status: "mga order, aking mga order, status, tracking",
  },
  incomplete: {
    ticketType: "Piliin ang uri ng ticket",
    ticketTitle: "Isulat ang pamagat ng ticket",
    updateNothing: "Piliin kung ano ang babaguhin sa ticket",
    tagsClash: "May tag na idinadagdag at inaalis nang sabay",
    ticketStatus: "Piliin ang status na paglilipatan ng ticket",
    assignTeam: "Piliin ang team na pagpipilian",
    assignUser: "Piliin ang taong ia-assign",
    assignSkills: "Idagdag ang mga skill na kailangan ng tao",
    noteText: "Isulat ang note",
    replyText: "Isulat ang sagot",
    replyAuthor: "Piliin kung aling miyembro ng team ang sumasagot",
    notifyAudience: "Piliin kung sino ang sasabihan",
    notifyChannel: "Piliin kung paano sila aabutin",
    linkVariable: "Ilagay ang variable na may numero ng ticket",
    ticketPolicy: "Piliin ang SLA policy",
    assetVariable: "Pangalanan ang variable na may tag o serial number",
    catalogueQuery: "Isulat kung ano ang hahanapin",
    catalogueVariable: "Pangalanan ang variable na may hinahanap na teksto",
    orderVariable: "Pangalanan ang variable na may order number",
  },
  problems: {
    no_ticket_here: "Walang ticket ang trigger na ito para sa hakbang na ito. Gumamit ng trigger ng ticket, o gumawa muna ng ticket.",
    link_needs_conversation: "Walang usapang mali-link ang trigger na ito.",
    link_event_no_ticket: "Hindi tungkol sa ticket at usapan nang sabay ang event ng trigger na ito. Mag-link gamit ang variable.",
    service_exits_not_here: "Hindi maipapadala ng workflow na kumakausap sa bisita ang {{step}} sa ibang path. Alisin ang mga exit, o patakbuhin ang workflow sa background.",
  },
  conditionGroups: {
    ticket: "Ticket",
    organisation: "Organisasyon",
    contact: "Contact ng kliyente",
    order: "Order",
    quote: "Quotation",
  },
  conditionFields: {
    ticket_number: "Numero ng ticket",
    ticket_type: "Uri ng ticket",
    ticket_category: "Kategorya ng uri",
    ticket_status: "Status ng ticket",
    ticket_status_category: "Kategorya ng status",
    ticket_priority: "Priority",
    ticket_channel: "Channel",
    ticket_team_id: "Team",
    ticket_assignee: "May assignee",
    ticket_assignee_id: "Assignee",
    ticket_tags: "Mga tag",
    ticket_organisation_id: "Organisasyon",
    ticket_org_tier: "Tier ng organisasyon",
    ticket_site_region: "Rehiyon ng site",
    ticket_asset_category: "Kategorya ng asset",
    ticket_has_asset: "May asset",
    ticket_contract_active: "Aktibo ang kontrata",
    ticket_warranty_status: "Status ng warranty",
    ticket_sla_policy: "SLA policy",
    ticket_sla: { first_response_state: "SLA sa unang sagot", resolution_state: "SLA sa resolusyon" },
    ticket_reopen_count: "Ilang beses nabuksan muli",
    ticket_requester_verified: "Verified ang humiling",
    ticket_language: "Wika ng ticket",
    ticket_origin: "Paano ginawa",
    ticket_created_in_office_hours: "Ginawa sa oras ng opisina",
    ticket_sentiment: "Paano ang tono ng kliyente",
    organisation_id: "Id ng organisasyon",
    organisation_tier: "Tier",
    organisation_industry: "Industriya",
    organisation_status: "Status",
    organisation_tags: "Mga tag",
    contact_org_role: "Tungkulin sa organisasyon",
    contact_can_order: "Puwedeng umorder",
    contact_verified: "Verified",
    contact_verified_via: "Na-verify sa pamamagitan ng",
    contact_language: "Wika",
    event_from: "Status bago",
    event_to: "Status pagkatapos",
    event_score: "Rating (1–5)",
    event_low: "Ang rating ay kapantay o mas mababa sa alert level",
    event_outcome: "Kinalabasan",
    event_metric: "SLA metric",
    event_n: "Aling paalala (1, 2 ...)",
    event_mentions: "Mga taong binanggit",
    order_status: "Status ng order",
    order_total_php: "Kabuuan ng order (PHP)",
    order_approval_state: "Estado ng pag-apruba",
    order_kind: "Paano ginawa ang order",
    order_connector_id: "Order system",
    order_line_count: "Bilang ng linya",
    order_has_backorder: "May linyang backorder",
    quote_status: "Status ng quotation",
    quote_source: "Paano hiniling ang quotation",
    quote_total_php: "Kabuuan ng quotation (PHP)",
    quote_line_count: "Bilang ng linya",
    quote_expired: "Nag-expire na ang quotation",
    event_final: "Pinal na ang desisyon",
    event_side: "Sino ang magpapasya (ang kliyente o ang aming team)",
    ticket_order_number: "Numero ng order",
    ticket_order_status: "Status ng order",
    ticket_order_items: "Mga item ng order",
  },
  conditionChoices: {
    ticket_priority: { low: "Mababa", normal: "Karaniwan", high: "Mataas", urgent: "Madalian" },
    ticket_sentiment: { negative: "Naiinis o galit", neutral: "Neutral", positive: "Masaya o nagpapasalamat" },
    ticket_status_category: { new: "Bago", open: "Bukas", pending: "Naghihintay sa kliyente", on_hold: "Naka-hold", resolved: "Na-resolve", closed: "Sarado" },
    ticket_category: { customer: "Request ng kliyente", back_office: "Back office", tracker: "Tracker" },
    ticket_channel: { widget: "Website widget", webapp: "Web app", mobile: "Mobile app", messenger: "Messenger", email: "E-mail", api: "API", console: "Console" },
    ticket_origin: {
      ai_intake: "Intake ng assistant",
      client_form: "Form ng kliyente",
      staff: "Ginawa ng staff",
      email: "E-mail",
      api: "API",
      workflow: "Isang workflow",
      conversation: "Mula sa usapan",
      handoff: "Isang handoff",
      order_issue: "Problema sa order",
      visit: "Isang field visit",
      punch_list: "Isang punch list",
      pm_plan: "Isang maintenance plan",
    },
    ticket_sla: {
      first_response_state: { ok: "Nasa tamang oras", warning: "Malapit na sa target", breached: "Napalampas", met: "Naabot", paused: "Naka-pause", "n/a": "Walang target" },
      resolution_state: { ok: "Nasa tamang oras", warning: "Malapit na sa target", breached: "Napalampas", met: "Naabot", paused: "Naka-pause", "n/a": "Walang target" },
    },
    contact_org_role: { org_admin: "Admin ng organisasyon", member: "Miyembro" },
    contact_verified_via: { widget_jwt: "Naka-sign in sa website", email_otp: "Code sa e-mail", magic_link: "Link sa e-mail", staff_verified: "Na-verify ng staff" },
    event_metric: { first_response: "Unang sagot", next_response: "Susunod na sagot", resolution: "Resolusyon", onsite_response: "Sagot sa site" },
  },
  addStepLock: "Hindi available ang Service Desk sa workspace na ito, kaya hindi maidaragdag ang mga hakbang nito.",
  service: {
    notSwitchedOn: "Hindi naka-on",
    priorities: { low: "Mababa", normal: "Karaniwan", high: "Mataas", urgent: "Madalian" },
    summaries: {
      anyType: "anumang uri",
      create_ticket: "Gumawa ng {{type}} na ticket: {{title}}",
      create_ticket_any: "Gumawa ng ticket: {{title}}",
      updateType: "uri na {{type}}",
      updatePriority: "priority na {{priority}}",
      updateTagsAdd: "idagdag ang mga tag na {{tags}}",
      updateTagsRemove: "alisin ang mga tag na {{tags}}",
      updateFields_one: "{{count}} sagot",
      updateFields_other: "{{count}} sagot",
      updateDue_one: "due sa loob ng {{count}} minuto",
      updateDue_other: "due sa loob ng {{count}} minuto",
      updateClearDue: "alisin ang due date",
      set_ticket_state: "Ilipat ang ticket sa {{status}}",
      route_ticket: "Ilapat ang routing rules ng workspace",
      assign_round_robin: "Salitan sa {{team}}",
      assign_least_open: "Ang may pinakakaunting bukas na ticket sa {{team}}",
      assign_skills_match: "Ayon sa skills sa {{team}}: {{skills}}",
      assign_user: "I-assign kay {{name}}",
      assign_unassign: "Alisin ang ticket sa assignee nito",
      add_ticket_note: "Note: {{text}}",
      reply_to_ticket: "Sagot bilang {{author}}: {{text}}",
      notify_contact: "Sabihan ang {{who}} sa pamamagitan ng {{channels}}: {{template}}",
      link_ticket: "I-link ang chat sa ticket sa {{variable}}",
      apply_ticket_sla: "Ilapat ang {{policy}}",
      request_csat: "Hingan ng rating ang kliyente",
      ticket_intake: "Tinatanggap ng assistant ang alalahanin ng kliyente",
      ticket_intake_typed: "Tinatanggap ng assistant ang {{type}} na request",
      show_ticket_form: "Ipakita ang form ng {{type}}",
      show_my_tickets: "Ipakita ang mga bukas na request ng kliyente",
      lookup_asset_event: "Hanapin ang asset na tinutukoy ng event",
      lookup_asset_ticket: "Hanapin ang asset na nakakabit sa ticket",
      lookup_asset_variable: "Hanapin ang asset sa {{variable}}",
      schedule_visit: "Magmungkahi ng {{kind}} na pagbisita na may hanggang {{windows}} oras",
      lookup_catalogue_query: "Hanapin ang mga produkto para sa “{{query}}”",
      lookup_catalogue_variable: "Hanapin ang mga produkto para sa teksto sa {{variable}}",
      lookup_catalogue_ticket_asset: "Hanapin ang mga piyesa para sa kagamitan ng ticket",
      check_order_status_event: "Basahin ang order na tinutukoy ng event",
      check_order_status_variable: "Basahin ang order number sa {{variable}}",
      check_order_status_latest: "Basahin ang pinakahuling order ng kliyente",
      show_catalogue_query: "Ipakita ang mga produkto para sa “{{query}}”",
      show_catalogue_message: "Ipakita ang mga produkto ayon sa hiniling ng kliyente",
      create_order: "Ipakita ang cart para kumpirmahin ng kliyente",
      show_order_status: "Ipakita ang mga kamakailang order ng kliyente",
    },
    fields: {
      variableInvalid: "Gumamit ng pangalang tulad ng var.serial_number: var. na sinusundan ng letra, numero o underscore.",
      lookupAssetHelp: "Naghahanap ng asset ng organisasyon ng kliyente at itinatabi ang nahanap para sa mga susunod na hakbang.",
      assetSource: "Paano hahanapin ang asset",
      assetSources: { event: "Mula sa event", ticket: "Mula sa ticket", variable: "Mula sa variable" },
      assetSourceHints: {
        event: "Ang asset na tinutukoy ng event (mga event ng maintenance at warranty).",
        ticket: "Ang asset na nakakabit sa ticket ng run.",
        variable: "Ang tag o serial number na hawak ng variable, halimbawa ang tinype ng kliyente.",
      },
      assetVariable: "Variable",
      assetVariableHint: "Ang run variable na may asset tag o serial number.",
      scheduleVisitHelp: "Nagmumungkahi ng pagbisita para sa ticket na may hanggang tatlong oras mula sa bakanteng oras ng inhinyero. Ang kliyente pa rin ang pipili ng oras.",
      visitKind: "Uri ng pagbisita",
      visitKinds: { corrective: "Corrective", pm: "Preventive maintenance", calibration: "Calibration", inspection: "Inspeksyon" },
      visitWindows: "Ilang oras ang ihahandog",
      visitWindowsHint: "Hanggang {{max}}.",
      visitDuration: "Haba ng pagbisita (minuto)",
      visitDurationHint: "Mula {{min}} hanggang {{max}} minuto.",
      visitEngineer: "Inhinyero",
      visitEngineerDefault: "Ang assignee ng ticket, o ang team nito",
      lookupCatalogueHelp: "Naghahanap sa katalogo ng mga produktong maaaring makita ng kliyenteng ito at itinatabi ang hanggang lima sa var.products.",
      catalogueSource: "Ano ang hahanapin",
      catalogueSources: { query: "Isang nakatakdang teksto", variable: "Ang teksto sa variable", ticket_asset: "Mga piyesa para sa kagamitan ng ticket" },
      catalogueSourceHints: {
        query: "Parehong salita sa bawat pagkakataon.",
        variable: "Mga salitang ibinigay ng naunang hakbang o ng kliyente.",
        ticket_asset: "Mga produktong akma sa kagamitang nakakabit sa ticket.",
      },
      catalogueQuery: "Hahanaping teksto",
      catalogueQueryHint: "Hanggang 200 character. Maaari kang gumamit ng mga variable.",
      catalogueVariable: "Variable",
      catalogueVariableHint: "Ang run variable na may hahanaping teksto.",
      catalogueCategory: "Kategorya (opsyonal)",
      catalogueCategoryHint: "Mga produkto lang sa kategoryang ito.",
      catalogueLimit: "Ilang produkto ang itatabi",
      catalogueLimitHint: "Hanggang {{max}}.",
      checkOrderHelp: "Bumabasa ng order ng sariling organisasyon ng run at itinatabi ang status nito sa var.order_status.",
      orderSource: "Aling order",
      orderSources: { event: "Ang order ng event", variable: "Order number sa isang variable", latest: "Ang pinakahuling order ng kliyente" },
      orderSourceHints: {
        event: "Ang mga order trigger lang ang may dalang order.",
        variable: "Order number tulad ng O-00042.",
        latest: "Ang huling order na ginawa ng kliyente.",
      },
      orderVariable: "Variable",
      orderVariableHint: "Ang run variable na may order number tulad ng O-00042.",
      showCatalogueHelp: "Ipinapakita bilang card ang mga produktong tumutugma sa paghahanap. Maaaring magdagdag ng isa sa cart ang kliyente; walang mao-order.",
      showCatalogueQueryHint: "Iwanang blangko para hanapin ang kasusulat lang ng kliyente. Maaari kang gumamit ng mga variable.",
      catalogueTimeout: "Isara ang card pagkatapos ng",
      catalogueTimeoutHint: "Kung walang gumamit ng card, magsasara ito at lalabas ang workflow sa Nagsara ang card.",
      createOrderHelp: "Ipinapakita ang cart ng kliyente bilang order na ire-review, may Kumpirmahin ang order at Kanselahin.",
      createOrderSafe: "Naipo-place lang ang order kapag tinap ng kliyente ang Kumpirmahin ang order sa card. Hindi sapat ang mga salita, sinusunod ang limitasyon at mga approver ng kliyente, at humihingi pa rin ng e-mail code ang malaking total. Hindi ito maaaring tumakbo sa background trigger.",
      orderTimeout: "Kanselahin ang review pagkatapos ng",
      orderTimeoutHint: "Kung hindi nagpasya ang kliyente sa oras, walang mao-order at lalabas ang workflow sa Kinansela.",
      showOrderStatusHelp: "Ipinapakita ang mga kamakailang order ng naka-sign in na kliyente (hanggang lima) at ang mga status nito. Ang hindi naka-sign in ay hihilingang mag-sign in muna.",
      choose: "Pumili…",
      typeGone: "Uri na wala na",
      noTypes: "Wala pang mapipiling uri ng ticket.",
      openSettings: "Buksan ang Service settings",
      exitsFacing: "Kinakausap ng workflow na ito ang bisita, kaya tumatakbo ang hakbang na ito sa turno nila at tumutuloy sa susunod na hakbang. Walang exit dito.",
      variables: "Mga variable na magagamit",
      ticketType: "Uri ng ticket",
      createTypeHint: "Ang uri ang nagtatakda ng mga field ng form, ng default na team at ng SLA ng bagong ticket.",
      ticketTitle: "Pamagat",
      ticketTitleHint: "Hanggang 140 character sa ticket. Puwedeng gumamit ng mga variable.",
      ticketDescription: "Paglalarawan",
      priority: "Priority",
      priorityTypeDefault: "Default ng uri",
      priorityKeep: "Iwanan kung ano ito",
      team: "Team",
      teamTypeDefault: "Default ng uri, o ang routing rules",
      tags: "Mga tag",
      tagsHint: "Paghiwalayin ang mga tag gamit ang kuwit.",
      tagsAdd: "Idagdag ang mga tag",
      tagsRemove: "Alisin ang mga tag",
      answers: "Mga sagot sa field ng ticket",
      answersHint: "Puwedeng gumamit ng variable ang bawat sagot, tulad ng {{example}}.",
      addAnswer: "Magdagdag ng sagot",
      removeAnswer: "Alisin ang sagot para sa {{name}}",
      noFields: "Wala pang custom field ang mga uri ng ticket ninyo.",
      notifyClient: "Padalhan ang kliyente ng e-mail na resibo",
      createVariables: "Pagkatapos ng hakbang na ito, ang {{number}} at {{id}} ang tumutukoy sa bagong ticket para sa mga susunod na hakbang.",
      updateIntro: "Ang itatakda mo lang dito ang magbabago; ang iba sa ticket ay mananatili.",
      typeKeep: "Iwanan ang uri",
      due: "Due date",
      dueModes: { keep: "Iwanan kung ano ito", set: "Itakda mula ngayon", clear: "Alisin" },
      dueIn: "Due sa loob ng (minuto)",
      dueInHint: "Mula sa sandaling tumakbo ang hakbang.",
      status: "Ilipat ang ticket sa",
      statusHint: "Sinusuri sa state machine ng ticket kapag tumakbo ang hakbang.",
      noStatuses: "Wala pang mapipiling status.",
      resolutionCode: "Resolution code",
      noCode: "Walang code",
      resolutionNote: "Resolution note",
      resolutionNoteHint: "Nananatili sa ticket kasama ng paglipat. Puwedeng gumamit ng mga variable.",
      stateMachine: "Ang exit na Failed ay paglipat na tinatanggihan ng state machine (halimbawa, resolve na nangangailangan ng code).",
      routeHelp: "Inilalapat ang routing rules ng workspace sa ticket, tulad ng bagong ticket mula sa console. Ang “Naibigay sa isang tao” ay may taong pinili ang isang rule; ang “Naghihintay sa queue” ay napunta sa pila ng team o walang rule na tumugma.",
      openRouting: "Buksan ang Service settings",
      assignMethod: "Paano pipiliin ang tao",
      assignMethods: {
        round_robin: "Salitan",
        least_open: "Pinakakaunting bukas na ticket",
        skills_match: "Ayon sa skills",
        user: "Isang piniling tao",
        unassign: "Walang sinuman (alisin sa assignee)",
      },
      assignMethodHints: {
        round_robin: "Isa-isang karapat-dapat na miyembro ng team.",
        least_open: "Ang karapat-dapat na miyembro na pinakakaunti ang bukas na ticket.",
        skills_match: "Miyembro ng team na may lahat ng skill sa ibaba.",
        user: "Laging iisang tao.",
        unassign: "Mananatili ang ticket sa team nito, walang assignee.",
      },
      teamPick: "Team na pagpipilian",
      teamOptional: "Team (opsyonal)",
      member: "Miyembro ng team",
      skills: "Mga kailangang skill",
      skillsHint: "Paghiwalayin ang mga skill gamit ang kuwit. Hanggang {{max}}.",
      noteText: "Note",
      noteHint: "Team lang ninyo ang nakakakita. Puwedeng gumamit ng mga variable at @mention.",
      mentions: "Bumanggit ng mga tao",
      mentionsHint: "Maaabisuhan sila. Hanggang {{max}}.",
      mentionsPlaceholder: "Walang binanggit",
      mentionsSelected_one: "{{count}} tao ang binanggit",
      mentionsSelected_other: "{{count}} tao ang binanggit",
      search: "Maghanap ng tao",
      noMatches: "Walang tumutugma",
      replyText: "Mensahe sa kliyente",
      replyHint: "Nakikita ng kliyente sa ticket. Puwedeng gumamit ng mga variable.",
      replyAuthor: "Isinulat bilang",
      authors: { system: "Ang Service Desk", user: "Isang miyembro ng team" },
      replyCap: "Hanggang {{count}} sagot lang ang naisusulat ng isang run sa isang ticket. Pagkatapos nito, lalaktawan ang hakbang na ito.",
      audience: "Sino ang sasabihan",
      audiences: {
        requester: "Ang humiling",
        participants: "Mga kalahok",
        org_admins: "Mga admin ng organisasyon",
        org_approvers: "Mga nag-aapruba ng order",
        visit_contact: "Ang contact sa pagbisita",
      },
      audienceLater: "Masasabihan ang mga nag-aapruba at ang contact sa pagbisita kapag naka-on na ang Orders at Field visits. Hanggang noon, walang masasabihan.",
      channels: "Paano sila aabutin",
      channelNames: { email: "E-mail", in_chat: "Sa bukas na chat", messenger: "Messenger" },
      channelsHint: "Sa taong may bukas na chat ngayon lang pupunta ang linya sa chat; sa Messenger, sa loob lang ng 24 na oras na window. Kung walang maabot, tatakbo ang exit na Skipped.",
      template: "Mensahe",
      templateHint: "Ang e-mail template na ipapadala. Nasa Service settings ang pananalita ng bawat isa.",
      templates: {
        ticket_received: "Natanggap namin ang inyong request",
        ticket_reply: "Sagot mula sa aming team",
        ticket_status: "May bagong status ang inyong request",
        ticket_waiting_reminder: "Hinihintay namin ang inyong sagot",
        ticket_resolved: "Na-resolve ang inyong request",
      },
      chatLine: "Linya para sa chat at Messenger",
      chatLineHint: "Iwanang walang laman para gamitin ang karaniwang linya ng mensahe. Puwedeng gumamit ng mga variable.",
      linkSource: "Aling ticket",
      linkSourceHint: "Mali-link ang chat sa ticket na ito, kaya magkasamang makikita ng staff ang dalawa.",
      linkSources: { variable: "Ang ticket na tinutukoy ng variable", event: "Ang ticket ng event" },
      linkEventLater: "Walang trigger sa release na ito na tumutukoy sa ticket at usapan nang sabay. Mag-link gamit ang variable.",
      linkVariable: "Variable",
      linkVariableHint: "Halimbawa var.ticket_number, na itinakda ng Gumawa ng ticket.",
      linkVariableInvalid: "Gamitin ang var. na sinusundan ng mga letra, numero o _.",
      slaPolicy: "SLA policy",
      slaPolicyHint: "Pinapalitan ang SLA policy ng ticket. Magsisimula ulit ang mga orasan nito mula ngayon.",
      policyGone: "Policy na wala na",
      slaNone: "Wala pang SLA policy para sa ticket.",
      csatHelp: "Hinihingan ng rating ang humiling para sa na-resolve na ticket. Nalalapat pa rin ang mga patakaran ng survey ng workspace: ang fatigue cap, at ang mga uri at code na lumalaktaw dito. Ang “Nasabihan ang kliyente” ay nangangahulugang naipadala ang survey.",
      intakeHelp: "Isa-isang tinatanong ng assistant ang kliyente tungkol sa alalahanin, sinusuri kung may bukas nang request tungkol dito, nagpapakita ng buod at gumagawa lang ng ticket kapag pinindot ng kliyente ang Submit.",
      intakeAnyType: "Hayaang alamin ng assistant",
      intakeTypeHint: "Pumili ng uri para laging iyon ang ibukas. Kung hindi, pipili ang assistant mula sa usapan at magtatanong kapag hindi sigurado.",
      intakeTimeout: "Isara ang buod pagkatapos ng",
      intakeTimeoutHint: "Kung walang ginawa ang kliyente sa loob ng panahong ito, tatakbo ang exit na Umalis ang kliyente.",
      formHelp: "Nakapirming form para sa isang uri ng ticket, walang assistant. Pupunan ito ng kliyente at pipindutin ang Submit.",
      formTypeHint: "Ipinapakita ng form ang mga field ng uring ito.",
      formTimeout: "Isara ang form pagkatapos ng",
      formTimeoutHint: "Kung hindi naipadala ng kliyente sa loob ng panahong ito, tatakbo ang exit na Hindi naipadala ang form.",
      myTicketsHelp: "Ipinapakita ang mga bukas na request ng verified na kliyente (hanggang lima) na may link sa My tickets. Hihilingin munang mag-verify ang kliyenteng hindi pa verified.",
    },
  },
  list: {
    areas: {
      orders_field_service: "Orders at field service",
    },
    areaNotes: {
      service_desk: "Mga ticket at kliyente",
      orders_field_service: "Mga order, quote, pagbisita at asset",
    },
    wdLabel: "Default {{id}}",
    triggerLabel: "Nagsisimula sa",
    stepsLabel: "Mga hakbang",
    kind: { inline: "tumatakbo sa mismong request", async: "tumatakbo sa background", facing: "tumatakbo sa chat" },
    filters: {
      label: "I-filter ang mga default na workflow",
      search: "Hanapin ayon sa pangalan, trigger o numero ng WD",
      searchLabel: "Maghanap ng workflow",
      state: "Estado",
      anyState: "Anumang estado",
      live: "Live",
      paused: "Naka-pause",
      off: "Naka-off bilang default",
      modified: "Binago",
      kind: "Uri",
      anyKind: "Para sa kliyente at background",
      facing: "Para sa kliyente",
      background: "Background",
      area: "Area",
      anyArea: "Bawat area",
      clear: "I-clear ang mga filter",
      emptyTitle: "Walang tumutugmang workflow",
      emptyBody: "I-clear ang paghahanap o ang mga filter para makita ulit ang lahat ng default.",
      count: "{{shown}} sa {{total}} ang ipinapakita",
    },
    module: {
      pausedTitle: "Naka-pause dahil naka-off ang {{module}}",
      pausedBody: "Kusa itong magsisimula ulit kapag in-on ninyo ang {{module}} sa Service settings. Walang nabura.",
      openSettings: "Buksan ang Service settings",
      resumeBlocked: "Ituloy (i-on muna ang module)",
      names: { orders: "Orders at catalogue", assets: "Mga asset", installations: "Mga proyekto at installation", visits: "Mga field visit" },
      badge: "Naka-off ang module",
    },
    locked: {
      title: "Kasama sa planong {{plan}} ang mga workflow ng Service desk",
      body: "Ang 18 default ng Service desk ang nagsasabi sa mga kliyente tungkol sa kanilang mga ticket, nagro-route ng mga bago at nagbababala bago mapalampas ang SLA. Naka-set up ang mga ito kapag kasama ng plano ninyo ang Service Desk.",
      cta: "Ihambing ang mga plano",
    },
    strong: {
      title: "Naka-pause ang {{name}} ({{id}})",
      resume: "Ituloy",
    },
    pause: {
      highImpact: "Mataas ang epekto ng default na ito. I-type ang pangalan nito para kumpirmahin.",
      typeLabel: "I-type ang pangalan para kumpirmahin",
      typeHint: "I-type ang “{{name}}” nang eksakto sa pagkakasulat.",
    },
  },
} as const;
